/**
 * 콤보 감쇠 시스템
 * 3초 비활동 시 콤보 리셋
 */

import type { TickSystem } from '@app-games/core';
import type { GameState } from '../state.js';
import type { GameAction } from '../actions.js';

export const comboSystem: TickSystem<GameState, GameAction> = {
  name: 'combo',

  update(state) {
    if (!state.isRunning) return state;
    if (state.combo.count === 0) return state;

    const now = Date.now();
    const timeSinceLastClick = now - state.combo.lastClickTime;

    if (timeSinceLastClick > state.combo.decayTime) {
      return {
        ...state,
        combo: {
          ...state.combo,
          count: 0
        }
      };
    }

    return state;
  }
};
